import React, { useEffect, useRef, } from "react";
import { useLocation } from 'react-router-dom';

//MUI
import { FormControl, Button, Stack } from "@mui/material";

//MUI ICONS
import SearchIcon from "@mui/icons-material/Search";
import DownloadForOfflineSharpIcon from "@mui/icons-material/DownloadForOfflineSharp";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';

//API
import { fni18n } from "../../services/commonService";
import { API } from "../../config";
import AuthenticationService from "../../pages/auth/AuthenticationService";
import { getAPI} from "../../services/commonService";

function setIcon(icon) {
  if (icon === 'Search') {
   return (<SearchIcon/>);
  }
  else if (icon === 'Down') {
   return (<DownloadIcon/>);
  }
  else if( icon === 'Save') {
    return (<SaveIcon/>);
   }
   else if (icon === 'Cancel') {
    return (<RefreshIcon/>);
   }
   else if (icon === 'Delete') {
    return (<DeleteIcon/>);
   }
   else if (icon === 'Refresh') {
    return (<RefreshIcon/>);
   }
   else if (icon === 'Close') {
    return (<CloseIcon/>);
   }
   else if (icon === 'Launch') {
    return (<LaunchIcon/>);
   }
   else if (icon === 'Modify') {
    return (<EditIcon/>);
   }
   else if (icon === 'Add') {
    return (<AddIcon/>);
   }
   else if (icon === 'Upload') {
    return (<UploadIcon/>);
   }

  return(<></>);
};

const UAuthButton = (props) => {
  const isUserId = AuthenticationService.getLoggedInUserID();
  const isBranchCd = AuthenticationService.getLoggedInUserBranchCd();
  const location = useLocation();
  const menuUrl = location.pathname;

  const icon = props.icon;
  const text = props.children;
  // const menuUrl = props.menuFrom;
  const variant = props.variant;

  const buttonRef = useRef(null);

  useEffect(() => {
    try {
      if (isUserId && menuUrl) {
        let data = {
          menuUrl : menuUrl,
          userId : isUserId,
          branchCd : isBranchCd,
        };
        getAPI(API.SYSTEM.CHECK_MENU_AUTH, data)
        .then((res) => {
          if (res.data && res.data === 10) {
            buttonRef.current.style.visibility = "visible";
          }
        })
        .catch((err) => {
          console.log("API connect fail!", err);
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [isUserId, menuUrl])

  return(
    <FormControl sx={{ width: 'auto', }}>
      <Stack direction="row">
        <Button
        ref={buttonRef} 
        variant={ variant || "contained" }
        color="primary"
        sx={{ boxShadow: 'none', visibility: "hidden", }} 
        onClick={()=>{props.onButtonClick(text)}}>
          {setIcon(icon)}
          {fni18n(text)}
        </Button>
      </Stack>
    </FormControl>
  )

};
export default UAuthButton;